<!--
 * @Description: 弹窗组件
 * @Autor: Zhongyu
 * @Date: 2021-09-05 18:28:22
 * @LastEditors: Zhongyu
 * @LastEditTime: 2021-09-10 11:46:23
-->
<template>
  <div class="default-modal">
    <el-dialog
      :title="title"
      :visible.sync="visible"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :width="width"
      :modal="modal"
      custom-class="modal-custom"
    >
      <slot slot="title" name="title"></slot>
      <slot></slot>
      <slot slot="footer" name="footer"></slot>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    // 是否显示弹窗
    visible: {
      type: Boolean,
      default: false
    },
    // 标题
    title: {
      type: String,
      default: ""
    },
    // 弹窗的宽度
    width: {
      type: String,
      default: "50%"
    },

    // 是否需要遮罩层
    modal: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="less">
@import "./index.less";
</style>
